//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FaqThemesAccordion from "./FaqThemesAccordion";
import FaqThemesDetails from "./FaqThemesDetails";

export default {
    name: "FaqThemes",
    components: {FaqThemesDetails, FaqThemesAccordion},
    data() {
        return {
            activeId: null,
            items: [],
        }
    },
    computed: {
        selectedDetails() {
            let selectedObject = this.items[this.activeId];
            return selectedObject ? (selectedObject?.items ?? []) : [];
        }
    },
    mounted() {
        const activeQuery = this.$route.query.faqid;
        if (activeQuery) {
            this.activeId = activeQuery
        }
    },
    async fetch() {
        await this.$axios.$get(`${API.main}/help`).then((response) => {
            this.items = response;
        })
    }
}
